<template>
    <div>
        <filtros @mudaUnidade="mudaUnidade" @mudaEsfera="mudaEsfera" />
        <tabela v-if="meianoite.txOcupacao" :unidade="unidade" :esfera="esfera" />
    </div>  
</template>

<script>
import Filtros from './filtros/Filtros.vue'
import Tabela from './tabela/Tabela.vue'

export default {
    components: {
        Filtros,
        Tabela
    },
    data() {
        return {
            unidade: '',
            esfera: ''
        }
    },
    computed: {
        meianoite () {
            return this.$store.getters['relatorios/getMeianoite']
        },
    },
    methods: {
        mudaUnidade(value) {
            this.unidade = value
        },
        mudaEsfera(value) {
            this.esfera = value
        },
    },
}
</script>

<style>
.listagem-container,
.listagem-tabela-container {
    max-width: 96%;
    width: 1200px;
    margin: 0 auto;
}

.page-item.active .page-link {
    z-index: 0!important;
}
</style>
